import { ResourceProps } from "react-admin";
import Icon from "@mui/icons-material/NightShelter";
import { Resource } from "../../enums";
import ListScreen from "./list";
import { EditScreen } from "./edit";

const givingBack: ResourceProps = {
  name: Resource.GIVING_BACK,
  icon: Icon,
  list: ListScreen,
  edit: EditScreen,
  options: {
    label: "Giving Back",
  },
};

export default givingBack;
